import { useState } from "react";
import { siteConfig } from "../config/siteConfig";
import BookingModal from "./BookingModal";
import { ChevronDown } from "lucide-react";

export default function Hero() {
  const [open, setOpen] = useState(false);

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-center justify-center text-center"
    >
      <div
        className="absolute inset-0 kenburns bg-cover bg-center"
        style={{ backgroundImage: `url(${siteConfig.heritage.hero})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/75" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-24 pb-20">
        <img
          src={siteConfig.hotel.logoUrl}
          alt={siteConfig.hotel.name}
          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 object-contain"
          style={{ filter: "drop-shadow(0 0 30px rgba(197, 160, 89, 0.4))" }}
          data-testid="hero-logo"
        />
        <p
          className="font-overline text-[#C5A059] mb-4 inline-flex items-center"
          data-testid="hero-location"
        >
          <span className="gold-divider mr-3"></span>
          {siteConfig.hotel.location} · Sri Lanka
          <span className="gold-divider ml-3"></span>
        </p>
        <h1
          className="font-display text-[#FAF9F6] text-5xl sm:text-6xl lg:text-7xl font-light leading-tight mb-4"
          data-testid="hero-title"
        >
          {siteConfig.hotel.name}
        </h1>
        <p
          className="font-display italic text-[#D4B06A] text-2xl sm:text-3xl mb-10"
          data-testid="hero-tagline"
        >
          {siteConfig.hotel.tagline}
        </p>
        <p className="text-[#FAF9F6]/85 max-w-2xl mx-auto text-base sm:text-lg mb-12 leading-relaxed">
          {siteConfig.hotel.shortDescription}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => setOpen(true)}
            className="btn-primary"
            data-testid="hero-book-now-btn"
          >
            Book Now
          </button>
          <a
            href="#rooms"
            className="btn-secondary"
            data-testid="hero-view-rooms-btn"
          >
            View Rooms
          </a>
          {siteConfig.features.showRestaurantBar && (
            <a
              href="#restaurant-bar"
              className="btn-secondary"
              data-testid="hero-restaurant-bar-btn"
            >
              Restaurant & Bar
            </a>
          )}
        </div>
      </div>

      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#FAF9F6]/80 hover:text-[#C5A059] transition-colors"
        data-testid="hero-scroll-down"
        aria-label="Scroll to About"
      >
        <ChevronDown className="w-7 h-7 animate-bounce" strokeWidth={1.5} />
      </a>

      <BookingModal open={open} onOpenChange={setOpen} />
    </section>
  );
}
